<template>
  <div class="agreement" :class="wrapperClasses">
    <BaseLabel
      v-if="label"
      :id="id"
      :number="number"
      :label="label"
      :label-description="labelDescription"
      :required="required"
      :help="help"
      :class="labelClasses"
    >
      <span v-html="label"></span>
      <a
        v-if="fullText"
        href="#"
        class="agreement__toggle"
        @click.prevent="toggle()"
      >
        <template v-if="revealed">{{ hideText }}</template>
        <template v-if="!revealed">{{ revealText }}</template>
      </a>
    </BaseLabel>

    <div :class="controlClasses">
      <BaseAgreement
        :id="id"
        v-model="data"
        :disabled="disabled"
        @input="emitEvent"
      ></BaseAgreement>
    </div>

    <div v-if="description || error" :class="descriptionClasses">
      <BaseControlDescription :id="id" :description="description" />
      <BaseControlError :id="id" :error="error" />
    </div>
    <transition name="slide-fade">
      <div
        v-show="revealed"
        class="agreement__full-text"
        :class="descriptionClasses"
      >
        {{ fullText }}
      </div>
    </transition>
  </div>
</template>

<script>
import BaseFormControl from "@/components/Base/Form/BaseFormControl";
import BaseAgreement from "@/components/Base/Controls/BaseAgreement";

export default {
  name: "AgreementControl",
  components: {
    BaseAgreement
  },
  extends: BaseFormControl,
  props: {
    fullText: {
      type: String,
      default: ""
    },
    shortText: {
      type: String,
      required: true
    },
    reveal: {
      type: Boolean,
      default: true
    },
    value: {
      type: [Number, Boolean],
      required: true
    },
    revealText: {
      type: String,
      default: "Pokaż pełną treść"
    },
    hideText: {
      type: String,
      default: "Ukryj treść"
    },
    inline: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      revealed: false,
      controlOptions: {
        labelClass: "form__label",
        inlineLabelClass: "col-form-label col-sm-10 form__label",
        controlClass: "form__control",
        inlineControlClass: "col-sm-2 form__control",
        descriptionClass: "form__control-description",
        inlineDescriptionClass: "col-sm-10 form__control-description"
      }
    };
  },
  methods: {
    toggle(v) {
      this.revealed = !this.revealed;
    }
  }
};
</script>

<style lang="scss">
.agreement {
  &__toggle {
    text-transform: uppercase;
    font-size: 0.8em;
    &:before {
      content: "(";
    }
    &:after {
      content: ")";
    }
  }
  .custom-control-label {
    float: right;
  }
  .form__control-description {
    padding-left: 50px;
  }
  &__full-text {
  }
}
</style>
